<template>
  <div class="modal sell-modal">
    <div class="overlay" @click="$parent.closeSellModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeSellModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">SELL ITEMS</div>
                <div class="sell-modal-items" v-if="$parent.inventoryItems.length">
                  <div class="sell-modal-item-header">
                    <span class="col-name">ITEM</span>
                    <span class="col-available">AVAILABLE</span>
                    <span class="col-qty-controls">QTY</span>
                    <span class="col-price">PRICE</span>
                  </div>
                  <div
                    class="sell-modal-item"
                    v-for="(item, index) in $parent.inventoryItems"
                    :key="index"
                    :class="{ selected: item._quantity > 0 }"
                  >
                    <span class="col-name">{{ item.game_name || (item.catalog_item && item.catalog_item.name) || item.short_name }}</span>
                    <span class="col-available">{{ item.amount }}</span>
                    <div class="col-qty-controls">
                      <button
                        class="qty-btn minus"
                        :disabled="item._quantity <= 0"
                        @click="decrement(item)"
                      >−</button>
                      <input
                        class="qty-value"
                        type="number"
                        min="0"
                        :max="item.amount"
                        v-model.number="item._quantity"
                        @input="clampQuantity(item)"
                      />
                      <button
                        class="qty-btn plus"
                        :disabled="item._quantity >= item.amount"
                        @click="increment(item)"
                      >+</button>
                    </div>
                    <input
                      class="col-price"
                      type="number"
                      min="0.01"
                      step="0.01"
                      v-model.number="item._price"
                      :disabled="item._quantity <= 0"
                      placeholder="0.00"
                    />
                  </div>
                </div>
                <div v-else class="no-items desc dark">
                  No items found in your inventory.
                </div>
                <div class="sell-modal-total" v-if="selectedItems.length">
                  <span>Total:</span>
                  <span class="total-value">{{ totalAmount.toFixed(2) }}</span>
                  <img src="../img/coin.svg" class="coin" />
                </div>
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input v-model="adminApproval" type="checkbox" />
                      <div class="checkbox"></div>
                      <span class="desc dark">
                        I understand this transaction requires admin approval
                      </span>
                    </div>
                  </label>
                </div>
                <button
                  class="button"
                  :disabled="!canSubmit"
                  @click="submitSellRequest"
                >
                  CREATE SELL REQUEST
                </button>
                <transition name="slide">
                  <div v-if="error" class="error-desc desc red">
                    {{ error }}
                  </div>
                </transition>
                <transition name="slide">
                  <div v-if="success" class="success-desc desc green">
                    {{ success }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "SellModal",
  data() {
    return {
      adminApproval: false,
      error: "",
      success: "",
      submitting: false,
    };
  },
  computed: {
    selectedItems() {
      return this.$parent.inventoryItems.filter((item) => item._quantity > 0);
    },
    totalAmount() {
      return this.selectedItems.reduce((sum, item) => {
        return sum + (item._quantity || 0) * (item._price || 0);
      }, 0);
    },
    canSubmit() {
      return (
        this.adminApproval &&
        this.selectedItems.length > 0 &&
        this.selectedItems.every(
          (item) => item._quantity > 0 && item._price > 0
        ) &&
        !this.submitting
      );
    },
  },
  methods: {
    increment(item) {
      if (item._quantity < item.amount) {
        item._quantity++;
      }
    },
    decrement(item) {
      if (item._quantity > 0) {
        item._quantity--;
      }
    },
    clampQuantity(item) {
      let val = parseInt(item._quantity, 10);
      if (isNaN(val) || val < 0) val = 0;
      if (val > item.amount) val = item.amount;
      item._quantity = val;
    },
    submitSellRequest() {
      if (!this.canSubmit) return;
      this.submitting = true;
      this.error = "";
      this.success = "";

      const items = this.selectedItems.map((item) => ({
        short_name: item.short_name,
        quantity: item._quantity,
        price: item._price,
      }));

      axios
        .post("user/sell-requests", { items })
        .then((res) => {
          if (res.data.status === "OK") {
            this.success = "Sell request created successfully!";
            setTimeout(() => {
              this.$parent.closeSellModal();
            }, 1500);
          } else {
            this.error = res.data.message || "Failed to create sell request";
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 422) {
              this.error =
                err.response.data.message || "Validation error. Check your items.";
            } else if (err.response.status === 404) {
              this.error = "Player not found on server. Please join the game first.";
            } else if (err.response.status === 503) {
              this.error = "Game server is currently unavailable. Please try again later.";
            } else {
              this.error =
                err.response.data.message || "Failed to create sell request";
            }
          } else {
            this.error = "Network error. Please try again.";
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
